import { render, staticRenderFns } from "./Taxation.vue?vue&type=template&id=da59a2ac&"
import script from "./Taxation.vue?vue&type=script&lang=js&"
export * from "./Taxation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports